export const init = () => {


  // TRACKER 'MAKE A RETURN'
  const tracker = new AnalyticsTracker(AnalyticsConstants.trackers.customer.account.returns);

  // PAGE : LIST ORDER

  // 0.1 : Make a return # ORDER_ID
  const makeAReturnFromOrderList = new AnalyticsClickEvent('makeAReturnFromOrderList', tracker.defaultEvent());
  makeAReturnFromOrderList.domContainer = '#current-orders';
  makeAReturnFromOrderList.domElement = '.make-return-button';
  makeAReturnFromOrderList.options.action = 'MakeAReturn';
  makeAReturnFromOrderList.getLabel = ($element) => $element.data('order-id');
  tracker.addEvent(makeAReturnFromOrderList);

  // 0.2 : Display Order
  // > DO NOT CREATE THIS EVENT HERE ?


  // PAGE : ORDER TRACKING
  // 1 : BTN MakeAReturn # ORDER_ID
  const makeAReturnFromOrderTracking = new AnalyticsClickEvent('makeAReturnFromOrderTracking', tracker.defaultEvent());
  makeAReturnFromOrderTracking.domContainer = '#order-detail-page';
  makeAReturnFromOrderTracking.domElement = '#makeReturnButton';
  makeAReturnFromOrderTracking.options.action = 'MakeAReturn';
  makeAReturnFromOrderTracking.getLabel = ($element) =>  $element.data('order-id');
  tracker.addEvent(makeAReturnFromOrderTracking);

  let selectedProductLabel = '';
  const getLabelFromElement = ($element) => {
    // TODO : var nature = $element.data('nature')
    const name = $element.find('.product-content [data-tdata="name"]').text().trim();
    const model = $element.data('modelid');
    selectedProductLabel = `${name  }|${  model}`;
    return selectedProductLabel;
  };
  // PAGE : REEX SELECTOR
  // 2 : BTN MakeAReturn on a Product # PRODUCT_NATURE|PRODUCT_NAME|MODEL_ID
  const selectReturnProduct = new AnalyticsClickEvent('selectReturnProduct', tracker.defaultEvent());
  selectReturnProduct.domContainer = '#reex-selector';
  selectReturnProduct.domElement = '.one-product:not(.blocked):not(.active)';
  selectReturnProduct.options.action = 'SelectReturnProduct';
  selectReturnProduct.getLabel = getLabelFromElement;
  tracker.addEvent(selectReturnProduct);

  // 2.1 : BTN ValidReturnedQuantity (queue?)  # PRODUCT_NATURE|PRODUCT_NAME|MODEL_ID
  // ! \\ Different triggers on DESKTOP & MOBILE
  const selectReturnedQuantity = new AnalyticsClickEvent('selectReturnedQuantity', tracker.defaultEvent());
  selectReturnedQuantity.domContainer = '#reex-selector';
  selectReturnedQuantity.domElement = '#selector-view-choice #goto-refund';
  selectReturnedQuantity.options.action = 'SelectReturnedQuantity';
  selectReturnedQuantity.getLabel = () => selectedProductLabel;
  selectReturnedQuantity.getValue = ($element) => $element.closest('.selector-content').find('.quantity-input').val();
  tracker.addEvent(selectReturnedQuantity);
  // FOR MOBILE ...
  const selectReturnedQuantityMob = new AnalyticsClickEvent('selectReturnedQuantityMob', tracker.defaultEvent());
  selectReturnedQuantityMob.domContainer = '#modal-selector-view-return-choice';
  selectReturnedQuantityMob.domElement = '.goto-mobile-refund';
  selectReturnedQuantityMob.options.action = 'SelectReturnedQuantity';
  selectReturnedQuantityMob.getLabel = () => selectedProductLabel;
  selectReturnedQuantityMob.getValue = ($element) => $element.closest('.modal-body').find('input.quantity-input').val();
  tracker.addEvent(selectReturnedQuantityMob);

  // 2.2 : BTN ValidReturnReason (queue?)  # PRODUCT_NATURE|PRODUCT_NAME|MODEL_ID
  // ! \\ Different triggers on DESKTOP & MOBILE
  const selectReturnReason = new AnalyticsClickEvent('selectReturnReason', tracker.defaultEvent());
  selectReturnReason.domContainer = '#reex-selector';
  selectReturnReason.domElement = '#selector-view-refund-choice .validateRefundButton:not(.cta-v2--disabled)';
  selectReturnReason.options.action = 'SelectReturnReason';
  selectReturnReason.getLabel = ($element) => `${selectedProductLabel  }|${  $element.closest('.selector-dropdown').find('select :selected').val()}`;
  tracker.addEvent(selectReturnReason);
  // FOR MOBILE ...
  const selectReturnReasonMob = new AnalyticsClickEvent('selectReturnReasonMob', tracker.defaultEvent());
  selectReturnReasonMob.domContainer = '#modal-selector-view-refund-choice';
  selectReturnReasonMob.domElement = '.validateRefundButton:not(.cta-v2--disabled)';
  selectReturnReasonMob.options.action = 'SelectReturnReason';
  selectReturnReasonMob.getLabel = ($element) => `${selectedProductLabel  }|${  $element.closest('.modal-body').find('#reason-refund-mobile :selected').val()}`;
  tracker.addEvent(selectReturnReasonMob);

  // 3.1 : BTN DeleteProduct (queue?) # PRODUCT_NATURE|PRODUCT_NAME|MODEL_ID
  const deleteProduct = new AnalyticsClickEvent('deleteProduct', tracker.defaultEvent());
  deleteProduct.domContainer = '#reex-sumup';
  deleteProduct.domElement = '.delete-item';
  deleteProduct.options.action = 'DeleteProduct';
  deleteProduct.getLabel = ($element) => {
    // Deleting in the ReexSumup > we do not have access to MODELID; only SKUID (data is not in the page's flux)
    // In the Reex Page > We have the list of ALL product with MODEL and SKU ID
    // So > Take the SKUID from HERE, and search the same SKUID with an existing MODELID in the page !
    const name = $element.closest('.one-item').find('img').attr('alt').trim();
    const skuId = $element.closest('.one-item').data('skuid');
    let modelId = '';
    if ($(`[data-skuid="${skuId}"][data-modelid]`).length)
      modelId = $(`[data-skuid="${skuId}"][data-modelid]`).first().data('modelid');
    return `${name  }|${  modelId}`;
  };
  tracker.addEvent(deleteProduct);

  // 3.2 : BTN CancelReturnOrder # RETURN_ID
  const cancelMyReturn = new AnalyticsClickEvent('cancelMyReturn', tracker.defaultEvent());
  cancelMyReturn.domContainer = '#reex-sumup';
  cancelMyReturn.domElement = '[data-tracking="btn-cancel-return"]:not(.disabled)';
  cancelMyReturn.options.action = 'CancelMyReturn';
  cancelMyReturn.getLabel = () =>  $('[data-orderid]').first().data('orderid');
  tracker.addEvent(cancelMyReturn);
  // 4.1 : BTN CancelCancelReturnOrder # RETURN_ID
  const cancelCancelMyReturn = new AnalyticsClickEvent('cancelCancelMyReturn', tracker.defaultEvent());
  cancelCancelMyReturn.domContainer = '#modal-cancel-exchange';
  cancelCancelMyReturn.domElement = '[data-dismiss]';
  cancelCancelMyReturn.options.action = 'CancelCancelMyReturn';
  cancelCancelMyReturn.getLabel = () => $('[data-orderid]').first().data('orderid');
  tracker.addEvent(cancelCancelMyReturn);
  // 4.2 : BTN ConfirmCancelReturnOrder # RETURN_ID
  const confirmCancelMyReturn = new AnalyticsClickEvent('confirmCancelMyReturn', tracker.defaultEvent());
  confirmCancelMyReturn.domContainer = '#modal-cancel-exchange';
  confirmCancelMyReturn.domElement = '#cancelReturnButton';
  confirmCancelMyReturn.options.action = 'ConfirmCancelMyReturn';
  confirmCancelMyReturn.getLabel = () => $('[data-orderid]').first().data('orderid');
  tracker.addEvent(confirmCancelMyReturn);

  // 3.2 : BTN ConfirmReturnOrder # RETURN_ID
  const confirmMyReturn = new AnalyticsClickEvent('confirmMyReturn', tracker.defaultEvent());
  confirmMyReturn.domContainer = '#reex-sumup';
  confirmMyReturn.domElement = '[data-tracking="btn-return"]:not(.disabled)';
  confirmMyReturn.options.action = 'ConfirmMyReturn';
  confirmMyReturn.getLabel = () => $('[data-orderid]').first().data('orderid');
  tracker.addEvent(confirmMyReturn);
  // 5.1 : BTN CancelConfirmReturnOrder # RETURN_ID
  const cancelConfirmMyReturn = new AnalyticsClickEvent('cancelConfirmMyReturn', tracker.defaultEvent());
  cancelConfirmMyReturn.domContainer = '#modal-continue-exchange';
  cancelConfirmMyReturn.domElement = '[data-dismiss]';
  cancelConfirmMyReturn.options.action = 'CancelConfirmMyReturn';
  cancelConfirmMyReturn.getLabel = () => $('[data-orderid]').first().data('orderid');
  tracker.addEvent(cancelConfirmMyReturn);
  // 5.2 : BTN ConfirmConfirmReturnOrder # RETURN_ID
  const confirmConfirmMyReturn = new AnalyticsClickEvent('confirmConfirmMyReturn', tracker.defaultEvent());
  confirmConfirmMyReturn.domContainer = '#modal-continue-exchange';
  confirmConfirmMyReturn.domElement = '#confirmReturnButton';
  confirmConfirmMyReturn.options.action = 'ConfirmConfirmMyReturn';
  confirmConfirmMyReturn.getLabel = () => $('[data-orderid]').first().data('orderid');
  tracker.addEvent(confirmConfirmMyReturn);


  // PAGE : REEX CONFIRMATION
  // 6.1 : BTN ReturnToListReturn
  const returnToListReturn = new AnalyticsClickEvent('returnToListReturn', tracker.defaultEvent());
  returnToListReturn.domContainer = '#confirmation-container';
  returnToListReturn.domElement = '#myReturnsButton';
  returnToListReturn.options.action = 'ReturnToListReturn';
  returnToListReturn.getLabel = () => $('[data-orderid]').first().data('orderid');
  tracker.addEvent(returnToListReturn);

  // 8.2 : BTN ViewReturnDetail
  const viewReturnDetail = new AnalyticsClickEvent('viewReturnDetail', tracker.defaultEvent());
  viewReturnDetail.domContainer = '#current-returns';
  viewReturnDetail.domElement = '.link-details';
  viewReturnDetail.options.action = 'ViewReturnDetail';
  viewReturnDetail.getLabel = ($element) => $element.attr('href').split('returnId=')[1];
  tracker.addEvent(viewReturnDetail);

  CUBE.Analytics.trackers.add(tracker);
  CUBE.Analytics.trackers.init(tracker.params.name);

};



// WEBPACK FOOTER //
// ./src/analytics/trackers/customer/return-tracker.js